import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import {connect} from "react-redux";
import {RouteComponentProps, withRouter} from 'react-router-dom';
import Select from 'react-select';
import {CREATE_FORM_STAGE, identityOptions, PAGE_TYPE, referenceOptions} from '../../Config/appConfig';
import {Auth, CoverNote, InsurerId, Option, SearchInput} from '../../Config/dataModel';
import enquiryDispatch from '../../ReduxRequests/Dispatch/enquiryDispatch';
import authState from '../../ReduxRequests/State/authState';
import enquiryState from '../../ReduxRequests/State/enquiryState';
import {assertTrue, clearErrors, throwErrorClient} from '../../Util/errorUtil';
import util from '../../Util/util';
import ErrorHandler from '../ErrorHandler/ErrorHandler';
import CloseButton from '../Custom/CloseButton';
import IdentityInput from '../Custom/IdentityInput';
import RecordsTableView from '../Records/RecordsTableView';
import '../../style/search.css';
import { reactSelectStyles } from '../constants';

const btnSpinner = require('../../resource/img/button-loading.gif');

const mapStateToProps = (state) => {
    return {
        ...enquiryState(state),
        ...authState(state)
    }
};

interface BatchSearchProps {
    auth: () => Auth,
    insurerId: () => InsurerId;
    searchResult: CoverNote[],
    search: (data: SearchInput) => void
}

interface SearchState {
    identity: Option,
    identityNo: string,
    checksum: string,
    reference: Option,
    referenceNo: string,
    result: CoverNote[],
    loading: boolean
}

class Search extends React.Component <RouteComponentProps & BatchSearchProps, SearchState> {
    public constructor(props: BatchSearchProps) {
        super(props);
        this.state = this.getInitialState();
        this.changeIdentity = this.changeIdentity.bind(this);
        this.changeIdentityNo = this.changeIdentityNo.bind(this);
        this.changeChecksum = this.changeChecksum.bind(this);
        this.changeReference = this.changeReference.bind(this);
        this.changeReferenceNo = this.changeReferenceNo.bind(this);
        this.clickReset = this.clickReset.bind(this);
        this.clickSubmit = this.clickSubmit.bind(this);
        this.onError = this.onError.bind(this);
    }

    public getInitialState() {
        return {
            identity: identityOptions[0],
            identityNo: '',
            checksum: '',
            reference: null,
            referenceNo: '',
            result: [],
            loading: false
        };
    }

    public componentDidMount() {
        if (this.props.location.state && this.props.location.state.searchResult && !this.state.result.length) {
            this.setState({
                result: this.props.location.state.searchResult,
                identity: this.props.location.state.identity,
                identityNo: this.props.location.state.identityNo,
                checksum: this.props.location.state.checksum
            });
            this.props.history.replace({
                state: undefined
            });
        }
    }

    public componentWillReceiveProps(nextProps: BatchSearchProps) {
        if (nextProps.searchResult !== this.props.searchResult) {
            if (!nextProps.searchResult.length) {
                throwErrorClient(101);
            }
            this.setState({
                result: nextProps.searchResult,
                loading: false
            });
        }
    }

    public changeIdentity(identity: Option) {
        this.setState({
            identity,
            identityNo: '',
            checksum: ''
        });
    }

    public changeIdentityNo(identityNo: string) {
        this.setState({
            identityNo
        });
    }

    public changeChecksum(checksum: string) {
        this.setState({
            checksum
        });
    }

    public changeReference(reference: Option) {
        this.setState({
            reference
        });
    }

    public changeReferenceNo(event: React.ChangeEvent<HTMLInputElement>) {
        event.preventDefault();
        this.setState({
            referenceNo: event.target.value
        });
    }

    public clickReset(event: React.MouseEvent<HTMLElement>) {
        event.preventDefault();
        clearErrors();
        this.setState(this.getInitialState());
    }

    public clickSubmit(event: React.MouseEvent<HTMLElement>) {
        event.preventDefault();
        clearErrors();
        if(!assertTrue(154, this.state.identityNo.length > 0)) { return; }
        if(!assertTrue(170, util.isIdentityNoValid(this.state.identity.value, this.state.identityNo, this.state.checksum))) { return; }

        this.setState({
            loading: true
        });
        const data = {
            ...{
                docId: util.getIdentityNo(this.state.identity.value, this.state.identityNo, this.state.checksum),
                docType: this.state.identity.value,
                chassisNumber: this.state.reference && this.state.reference.value === referenceOptions[0].value ? this.state.referenceNo : '',
                midasRef: this.state.reference && this.state.reference.value === referenceOptions[1].value ? this.state.referenceNo : '',
                policyRef: this.state.reference && this.state.reference.value === referenceOptions[2].value ? this.state.referenceNo : ''
            }, ...this.props.insurerId()
        };
        this.props.search(data);
    }

    public onError() {
        this.setState({
            loading: false
        });
    }

    public render() {
        let closeButtonExtraProps = {};
        if (this.props.location.state && this.props.location.state.fromDashboard) {
            closeButtonExtraProps = {...closeButtonExtraProps, ...{goBack: true}};
        }
        return (
            <div className="cmHorCenter cmFormContainer">
                <div className="cmFormTitleHeader">
                    <div className="cmFormTitle">Search</div>
                    <CloseButton {...closeButtonExtraProps}/>
                </div>
                <div>
                    <div>
                        <div className="cmInput">
                            <IdentityInput
                                stage={CREATE_FORM_STAGE.CREATE}
                                identity={this.state.identity}
                                identityNo={this.state.identityNo}
                                checksum={this.state.checksum}
                                changeIdentity={this.changeIdentity}
                                changeIdentityNo={this.changeIdentityNo}
                                changeChecksum={this.changeChecksum}/>
                        </div>
                        <div className="cmInput cmInput2Cols">
                            <Grid className="cmInput2ColsLeft" item xs={6}>
                                <label className="cmInputLabel">Supporting reference</label>
                                <Select
                                    styles={reactSelectStyles}
                                    className="react-select__container"
                                    classNamePrefix="react-select"
                                    options={referenceOptions}
                                    value={this.state.reference}
                                    clearable={true}
                                    placeholder="Optional"
                                    onChange={this.changeReference}/>
                            </Grid>
                            <Grid className="cmTextFieldContainer" item xs={6}>
                                <input
                                    className="cmText"
                                    type="text"
                                    value={this.state.referenceNo}
                                    onChange={this.changeReferenceNo}/>
                            </Grid>
                        </div>
                    </div>
                    {this.state.result.length ?
                        <div className="searchResult records">
                            <RecordsTableView
                                page={PAGE_TYPE.SEARCH}
                                list={this.state.result}
                                searchResult={this.state.result}
                                identity={this.state.identity}
                                identityNo={this.state.identityNo}
                                checksum={this.state.checksum}/>
                        </div> : null}
                    <ErrorHandler onError={this.onError}/>
                </div>
                <div className="cmBtnsContainer">
                    <div className="cmBtnWrapper">
                        <button className="cmBtn cmGreyBtn cmBoldText" onClick={this.clickReset}
                                disabled={this.state.loading}>Reset
                        </button>
                    </div>
                    <div className="cmBtnWrapper">
                        <button className="cmBtn cmBlueBtn cmBoldText" onClick={this.clickSubmit}
                                disabled={this.state.loading}>
                            <span className="cmBtnText">Submit</span>
                            {this.state.loading && <img className="cmBtnSpinner" src={btnSpinner}/>}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(connect(mapStateToProps, enquiryDispatch)(Search));



// WEBPACK FOOTER //
// ./src/Components/Search/Search.tsx